<template>
  <v-dialog v-model="dialog" max-width="80vw" persistent>
    <v-card>
      <v-card-text class="pt-10 body-1">
        <create-company
          v-show="createCompany"
          ref="createCompany"
          @continue="continueProcess"
        ></create-company>
        <create-customer v-show="!createCompany"></create-customer>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeCustomerDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CreateCompany from '@/components/create-company';
import CreateCustomer from '@/components/create-customer';

export default {
  name: 'CreateNewCustomer',
  components: {
    CreateCompany,
    CreateCustomer,
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: () => {
        return false;
      },
    },
  },
  data: () => ({
    createCompany: true,
  }),
  methods: {
    closeCustomerDialog() {
      this.$refs.createCompany.isAbnValid = false;
      this.$refs.createCompany.valid = false;
      this.$refs.createCompany.abn = null;
      // this.$store.dispatch('orders/company/resetCompany');
      // this.$store.dispatch('orders/customer/resetCustomer');
      // this.$store.dispatch('orders/address/resetAddress');
      this.$store.dispatch('orders/resetOrder');
      this.createEmployee = false;
      this.createCompany = true;
      this.$emit('closeCustomerDialog');
    },
    continueProcess() {
      this.createEmployee = true;
      this.createCompany = false;
    },
  },
};
</script>
